import { CmisResponse, GbCmisService } from '../../../core/gb-api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppPermissionService } from '../../../core/services/app-permission.service';

export type CmisItemType = 'Geschaeft' | 'Grundstueck';

export type CmisDocumentTarget = {
  [K in CmisItemType]: { itemType: K; id: string; tooltipParam: string };
}[CmisItemType];

@Injectable()
export class CmisService {
  constructor(
    private api: GbCmisService,
    private permissionService: AppPermissionService
  ) {}

  getDocuments(target: CmisDocumentTarget): Observable<CmisResponse> {
    switch (target.itemType) {
      case 'Geschaeft':
        return this.api.getCmisGeschaeft(target.id);
      case 'Grundstueck':
        return this.api.getCmisGrundstueck(target.id);
    }
  }

  hasPermission(itemType: CmisItemType): boolean {
    switch (itemType) {
      case 'Geschaeft':
        return this.permissionService.hasPermission('GESCHAEFT_PDF_LINK_CMIS');
      case 'Grundstueck':
        return this.permissionService.hasPermission('GRUNDSTUECK_PDF_LINK_CMIS');
    }
  }
}
